/** 后端尚未生成标题时的占位标题。 */
export function isGeneratedTitlePlaceholder(title: string | undefined): boolean {
  return !title || /^会话 \d+$/.test(title);
}
